(function () {
  // Scroll reveal — IntersectionObserver
  var prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (prefersReduced) {
    document.querySelectorAll('.image-gallery .reveal').forEach(function (el) {
      el.classList.add('visible');
    });
  } else {
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.15 });

    document.querySelectorAll('.image-gallery .reveal').forEach(function (el) {
      observer.observe(el);
    });
  }

  // Lightbox
  function buildMedia(btn) {
    var type = btn.dataset.zoomType;
    if (type === 'youtube') {
      var iframe = document.createElement('iframe');
      iframe.src = 'https://www.youtube.com/embed/' + encodeURIComponent(btn.dataset.zoomYoutubeId || '') + '?autoplay=1&rel=0&modestbranding=1&playsinline=1';
      iframe.title = 'Video';
      iframe.allow = 'autoplay; encrypted-media; picture-in-picture; fullscreen';
      iframe.allowFullscreen = true;
      return iframe;
    }
    if (type === 'video') {
      var video = document.createElement('video');
      video.controls = true;
      video.autoplay = true;
      video.playsInline = true;
      video.preload = 'metadata';
      (btn.dataset.zoomSources || '').split('|').forEach(function (entry) {
        if (!entry) return;
        var parts = entry.split('~');
        var source = document.createElement('source');
        source.src = parts[0];
        if (parts[1]) source.type = parts[1];
        video.appendChild(source);
      });
      return video;
    }
    var img = document.createElement('img');
    img.src = btn.dataset.zoomSrc || '';
    img.alt = btn.dataset.zoomAlt || '';
    return img;
  }

  function openLightbox(modal, trigger) {
    modal.hidden = false;
    modal._trigger = trigger;
    document.body.style.overflow = 'hidden';
    var closeBtn = modal.querySelector('.gallery-lightbox__close');
    if (closeBtn) closeBtn.focus();
  }

  function closeLightbox(modal) {
    modal.hidden = true;
    document.body.style.overflow = '';
    var holder = modal.querySelector('[data-lightbox-media]');
    if (holder) holder.innerHTML = '';
    if (modal._trigger) {
      modal._trigger.focus();
      modal._trigger = null;
    }
  }

  function trapFocus(modal, e) {
    var focusable = Array.from(
      modal.querySelectorAll('button:not([disabled]), a[href], video[controls]')
    );
    if (!focusable.length) return;
    var first = focusable[0];
    var last = focusable[focusable.length - 1];
    if (e.shiftKey) {
      if (document.activeElement === first) { e.preventDefault(); last.focus(); }
    } else {
      if (document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  }

  document.querySelectorAll('.gallery-item__zoom').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var modal = document.getElementById(btn.dataset.lightbox);
      if (!modal) return;
      var holder = modal.querySelector('[data-lightbox-media]');
      if (holder) {
        holder.innerHTML = '';
        holder.appendChild(buildMedia(btn));
      }
      var caption = modal.querySelector('[data-lightbox-caption]');
      if (caption) {
        var text = btn.dataset.zoomCaption || '';
        caption.textContent = text;
        caption.hidden = !text;
      }
      openLightbox(modal, btn);
    });
  });

  document.querySelectorAll('.gallery-lightbox').forEach(function (modal) {
    modal.querySelectorAll('[data-close-lightbox]').forEach(function (el) {
      el.addEventListener('click', function () { closeLightbox(modal); });
    });

    modal.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { closeLightbox(modal); return; }
      if (e.key === 'Tab') trapFocus(modal, e);
    });
  });
})();
